import React, { Component } from 'react'
import queryString from 'querystringify'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Content from '../../ui/Content'
import Helmet from 'react-helmet'
import Section from '../../ui/Section'

class IFrame extends Component {
  constructor () {
    super()
    this.state = {
      loaded: false,
      loadCheck: null
    }
    this.checkLoadingState = this.checkLoadingState.bind(this)
  }

  componentDidMount () {
    this.setState({
      loadCheck: setInterval(this.checkLoadingState, 1000)
    })
  }

  checkLoadingState () {
    const { loaded, loadCheck } = this.state
    if (!loaded && global.iFrameResize) {
      global.iFrameResize()
      this.setState({ loaded: true })
      clearInterval(loadCheck)
    }
  }

  generateUrl () {
    const {
      forwardQueryParams,
      location,
      url
    } = this.props

    if (forwardQueryParams === 'yes') {
      const [ path, query = '' ] = url.split('?')
      const existingQuery = queryString.parse(query)
      const combinedQuery = { ...existingQuery, ...location.query }
      return `${path}?${queryString.stringify(combinedQuery)}`
    }

    return url
  }

  render () {
    const {
      alignment,
      background,
      classNames,
      foreground,
      size,
      spacing,
      title
    } = this.props

    return (
      <Section
        alignment={alignment}
        background={background}
        foreground={foreground}
        size={size}
        spacing={spacing}>

        <Helmet
          script={[{
            src: 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.6/iframeResizer.min.js'
          }]}
        />

        <Content title={title}>
          <div className={classNames.root}>
            <iframe
              src={this.generateUrl()}
              scrolling='no'
              style={{width: '100%', border: 'none'}}
            />
          </div>
        </Content>
      </Section>
    )
  }
}

export default compose(
  withRouter,
  withStyles(styles)
)(IFrame)



// WEBPACK FOOTER //
// ./components/slices/IFrame/index.js